const quickLinks = [
  { label: 'Hizmetler', href: '#hizmetler' },
  { label: 'Araçlar', href: '#araclar' },
  { label: 'Süreç', href: '#surec' },
  { label: 'Blog', href: '#blog' },
  { label: 'Hakkımızda', href: '#hakkimizda' },
  { label: 'İletişim', href: '#iletisim' },
];

const services = [
  'Genel Muhasebe',
  'Vergi Danışmanlığı',
  'SGK ve Bordro',
  'Şirket Kuruluş',
  'Finansal Raporlama',
  'Teşvik Danışmanlığı',
];

export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#F5F7FA] border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-[#0A2540] rounded-lg">
                <i className="ri-bar-chart-box-line text-white text-base"></i>
              </div>
              <span className="font-bold text-[#0A2540] text-base">Özgür Çakmak SMMM</span>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-5">
              Mali süreçlerinizde güvenilir, şeffaf ve sürdürülebilir danışmanlık hizmeti.
            </p>
            <div className="flex items-center gap-3">
              {['ri-linkedin-line', 'ri-twitter-x-line', 'ri-instagram-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow noreferrer"
                  className="w-8 h-8 flex items-center justify-center bg-white border border-gray-200 rounded-lg text-gray-500 hover:text-[#0A2540] hover:border-[#0A2540] transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#0A2540] font-semibold text-sm mb-4">Hızlı Erişim</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                    className="text-gray-500 text-sm hover:text-[#0A2540] transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[#0A2540] font-semibold text-sm mb-4">Hizmetler</h4>
            <ul className="space-y-2.5">
              {services.map((s) => (
                <li key={s}>
                  <a
                    href="#hizmetler"
                    onClick={(e) => { e.preventDefault(); handleNav('#hizmetler'); }}
                    className="text-gray-500 text-sm hover:text-[#0A2540] transition-colors cursor-pointer"
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#0A2540] font-semibold text-sm mb-4">İletişim</h4>
            <div className="space-y-3">
              {[
                { icon: 'ri-map-pin-line', text: 'Aydınlı Mah. Mayıs Sok. Adres Lobi Sitesi B Blok No:2B/4 Tuzla/İstanbul' },
                { icon: 'ri-phone-line', text: '0 530 095 32 30' },
                { icon: 'ri-mail-line', text: 'info@ozgurcakmak.com.tr' },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-2.5">
                  <div className="w-5 h-5 flex items-center justify-center text-gray-400">
                    <i className={`${item.icon} text-sm`}></i>
                  </div>
                  <span className="text-gray-500 text-sm">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-gray-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-gray-400 text-xs">
            © 2026 Akın SMMM. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" rel="nofollow" className="text-gray-400 text-xs hover:text-gray-600 transition-colors cursor-pointer">Gizlilik Politikası</a>
            <a href="#" rel="nofollow" className="text-gray-400 text-xs hover:text-gray-600 transition-colors cursor-pointer">Kullanım Şartları</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
